const sortByEntityName = (a, b) => a.entityName.toLowerCase().localeCompare(b.entityName.toLowerCase());

const getChildren = (list, id) => {
	if (id) return list.filter(({pid}) => pid === id).sort(sortByEntityName);
	return list
		.filter(({ pid = undefined }) => !list.some((t) => t.id === pid))
		.sort(sortByEntityName);
};

const hasChildren = (list, id) => getChildren(list, id).length !== 0;

const assignChildren = (list, id = undefined) => {
	const children = getChildren(list, id);
	if (children.length !== 0) {
		return [...children].map((team) =>
			hasChildren(list, team.id) ? {...team, children: assignChildren(list, team.id)} : {...team}
		);
	}
	return [...children];
};

export default (teams) => {
	return assignChildren(teams);
};
